import React from 'react';
import { Section } from '../../components/section';
import { shorthand } from '../../utils/css-utils';
import { ItemsColumn } from './item-column';
export var SectionItemGridHorizontal = function (props) {
    var section = props.section, cssClass = props.cssClass, isRtl = props.isRtl;
    var innerPadding = section.innerPadding, outerPadding = section.outerPadding, leftColumnPadding = section.leftColumnPadding, rightColumnPadding = section.rightColumnPadding, spacerHeight = section.spacerHeight;
    var numberOfRows = section.items.length / 2;
    return (React.createElement(React.Fragment, null, Array(Math.ceil(numberOfRows))
        .fill(0)
        .map(function (_, idx) {
        var _a;
        return (React.createElement(Section, { key: section.items[idx * 2].id + "_" + ((_a = section.items[idx * 2 + 1]) === null || _a === void 0 ? void 0 : _a.id), backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: shorthand(outerPadding) },
            React.createElement(ItemsColumn, { section: section, item: section.items[idx * 2], padding: innerPadding
                    ? (idx === 0 ? innerPadding.top : spacerHeight) + "px " + (isRtl ? leftColumnPadding : rightColumnPadding) + " " + (idx === numberOfRows - 1
                        ? innerPadding.bottom
                        : spacerHeight) + "px " + innerPadding.left + "px"
                    : '', width: section.leftColumnWidth }),
            React.createElement(ItemsColumn, { section: section, item: section.items[idx * 2 + 1], padding: innerPadding
                    ? (idx === 0 ? innerPadding.top : spacerHeight) + "px " + innerPadding.right + "px " + (idx === numberOfRows - 1
                        ? innerPadding.bottom
                        : spacerHeight) + "px " + (isRtl ? rightColumnPadding : leftColumnPadding)
                    : '', width: section.rightColumnWidth })));
    })));
};
//# sourceMappingURL=section-item-grid-horizontal.js.map